import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddCommunications({
  open,
  onClose,
  setOpen,
}: ModalProps) {
  const [audienceType, setAudienceType] = useState("");
  const [messageType, setMessageType] = useState("");
  const [sendMode, setSendMode] = useState("now");

  return (
    <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
      <div className="modal-dialog take_action_modal">
        <div className="modal-body">

          {/* Header */}
          <div className="modal_title">
            <h2>Send Message</h2>
            <button className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </button>
          </div>

          <form className="form">
            <div className="gap_p">

              {/* Audience */}
              <div className="control_group">
                <label htmlFor="audience-type">Audience</label>
                <Select
                  fullWidth
                  displayEmpty
                  value={audienceType}
                  onChange={(e) => setAudienceType(e.target.value)}
                  inputProps={{ id: "audience-type" }}
                >
                  <MenuItem value=""><em>Select audience...</em></MenuItem>
                  <MenuItem value="single">Single Customer</MenuItem>
                  <MenuItem value="segment">Customer Segment</MenuItem>
                  <MenuItem value="dynamic">Dynamic Segment</MenuItem>
                  <MenuItem value="csv" disabled>
                    Manual Upload (CSV – coming soon)
                  </MenuItem>
                </Select>

                {audienceType && (
                  <p className="helper_text">
                    This message will be sent to <b>1,540 customers</b>
                  </p>
                )}
              </div>

              {/* Message Type */}
              <div className="control_group">
                <label>Message Type <span className="required">*</span></label>
                <RadioGroup
                  row
                  value={messageType}
                  onChange={(e) => setMessageType(e.target.value)}
                >
                  <FormControlLabel
                    value="transactional"
                    control={<Radio />}
                    label="🧾 Transactional"
                  />
                  <FormControlLabel
                    value="marketing"
                    control={<Radio />}
                    label="📣 Marketing"
                  />
                  <FormControlLabel
                    value="service"
                    control={<Radio />}
                    label="⚠ Service / Alert"
                  />
                </RadioGroup>
              </div>

              {/* Channel */}
              <div className="control_group">
                <label htmlFor="comm-channel">Channel</label>
                <Select fullWidth defaultValue="email" inputProps={{ id: "comm-channel" }}>
                  <MenuItem value="email">Email</MenuItem>
                  <MenuItem value="sms">SMS</MenuItem>
                  <MenuItem value="push">Push</MenuItem>
                  <MenuItem value="inapp">In-App</MenuItem>
                </Select>
              </div>

              {/* Subject */}
              <div className="control_group">
                <label htmlFor="comm-subject">Subject</label>
                <TextField fullWidth placeholder="Message subject..." inputProps={{ id: "comm-subject" }} />
              </div>

              {/* Message */}
              <div className="control_group ai_rec_btn">
                <label htmlFor="comm-message">Message</label>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  placeholder="Write your message..."
                  inputProps={{ id: "comm-message" }}
                />
                <Button className="btn btn_primary sm">
                  <img src="/static/images/ai_icon.svg" alt="icon" /> Generate with AI
                </Button>
              </div>

              {/* Scheduling */}
              <div className="control_group">
                <label>Send Options</label>
                <RadioGroup
                  row
                  value={sendMode}
                  onChange={(e) => setSendMode(e.target.value)}
                >
                  <FormControlLabel value="now" control={<Radio />} label="Send Now" />
                  <FormControlLabel value="schedule" control={<Radio />} label="Schedule" />
                </RadioGroup>
              </div>

              {sendMode === "schedule" && (
                <>
                  <div className="control_group">
                    <label htmlFor="schedule-time">Schedule Time</label>
                    <TextField type="datetime-local" fullWidth inputProps={{ id: "schedule-time" }} />
                  </div>

                  <div className="control_group">
                    <label htmlFor="rate-limit">Rate Limit (per minute)</label>
                    <TextField type="number" fullWidth placeholder="e.g. 500" inputProps={{ id: "rate-limit" }} />
                  </div>
                </>
              )}

              {/* Delivery Preview */}
              <div className="preview_box">
                <h4>Delivery Preview</h4>
                <p><b>Audience:</b> Cart Abandoners</p>
                <p><b>Total customers:</b> 1,540</p>
                <p><b>Eligible for Email:</b> 1,210</p>
                <p className="danger"><b>Blocked (no consent):</b> 330</p>
              </div>

            </div>

            {/* Footer */}
            <div className="footer_btn_flex">
              <Button className="btn btn_primary">
                Send Message
              </Button>
            </div>

          </form>
        </div>
      </div>
    </Modal>
  );
}
